import { useRef, useState } from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import usePostService from '../services/postService';
import UserImage from '../../components/UserImage';
import { AgendaUser} from '../../graphql/API';
import { useTranslation } from 'react-i18next';
import { IoSend } from "react-icons/io5";
import { Button, Image, Modal } from 'react-bootstrap';
import { DEFAULT_USER_IMAGE } from '../../config';
import CustomModal from '../../components/Modals/CustomModal';
import { Input as ReactInput } from '@aws-amplify/ui-react';

interface IInput {
    user: AgendaUser;
    comId: string;
    locale: string;
    room: string;
    receiverId?: string | null;
}

const Input = ({user, comId, locale = "en", room, receiverId = null}: IInput) => {
    // AUTH
    const {userId} = useAuthContext();
    // I18N
    const { t } = useTranslation();
    // SERVICES
    const [file, setFile] = useState(null);
    const [selectedPhoto, setSelectedPhoto] = useState<File | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    // NEW POST STATE
    const [newPost, setNewPost] = useState("");
    // REF
    const fileInputRef = useRef(null);
    // MODAL
    const [contentModal, setContentModal] = useState(null);
    const [linkModal, setLinkModal] = useState(null);
    const [showCustomModal, setShowCustomModal] = useState(false);
    const [footerModal, setFooterModal] = useState(true);

    const {onCreatePost} = usePostService(comId, null, user?.image, user?.username, user?.FCMtoken);

    const truncate = (str: string | undefined, maxlength: number) => {
        if (str) {
          return (str.length > maxlength) ?
          str.slice(0, maxlength - 1) + '…' : str;
        } else {
          return str;
        }
    };

    const submit = () => {
        onCreatePost(truncate(newPost, 300), room, receiverId, selectedPhoto);
        setNewPost('');
        setFile(null);
        setSelectedPhoto(null);
        setPreviewUrl(null);
    };

    const onChangePicture = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
          setFile(file);
          setSelectedPhoto(file);
          // Génère une URL pour afficher l'aperçu
          const url = URL.createObjectURL(file);
          setPreviewUrl(url);
        }
    };

    const selectPicture = async () => {
        if (selectedPhoto) {
            deleteOrChangePicture();
        } else {
            fileInputRef.current.click();
        }
    };

    const deleteOrChangePicture = () => {
        setFooterModal(false);
        setContentModal(
        <>
            <Modal.Header closeButton>
            <Modal.Title>{t('post.deleteOrChangeTitle')}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
            <p>{t('post.deleteOrChangeMessage')}</p>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={() => {fileInputRef.current.click(); setShowCustomModal(false);}}>
            {t('post.imageChange')}
            </Button>
            <Button variant="primary" onClick={() => {
                setSelectedPhoto(null);
                setFile(file);
                setPreviewUrl(null);
                setShowCustomModal(false);}}>
            {t('post.imageDelete')}
            </Button>
        </Modal.Footer>
        </>);
        setShowCustomModal(true);
    }

    return (
        <>
            <CustomModal
                show={showCustomModal}
                onHide={() => setShowCustomModal(false)}
                link={linkModal}
                children={contentModal}
                isFooter={footerModal}
            />
            <div className="post_input_wrapper" >
                <div className="post_input_container" >
                    <span onClick={selectPicture}>
                        { previewUrl ?
                            <Image src={previewUrl || DEFAULT_USER_IMAGE} className="userImage_sm shadow-sm hover:shadow-md" />
                        :
                            <Image src="/post/addImage.png" className="userImage_sm shadow-sm hover:shadow-md" />
                        }
                    </span>
                    <textarea
                        value={newPost}
                        onChange={(e) => setNewPost(e.target.value)}
                        placeholder={t('post.writeComment')}
                        rows={1}
                        className="post_textArea"
                    />
                    <ReactInput type="file" title={"Import Post Image"} 
                        onChange={onChangePicture} 
                        className="mt-4 mb-4 form-control" 
                        ref={fileInputRef}
                        style={{ display: 'none' }} 
                        accept="image/*"
                    />
                    <span onClick={submit} className="post_button">
                        {/* {t('post.submit')} */}
                        <IoSend size={20} />
                    </span>
                </div>
            </div>
        </>
    );

};
export default Input;